import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const HomeFilter = () => {
  const year = [
1900, 1901, 1902, 1903, 1904, 1905, 1906, 1907, 1908, 1909, 1910, 1911,
1912, 1913, 1914, 1915, 1916, 1917, 1918, 1919, 1920, 1921, 1922, 1923,
1924, 1925, 1926, 1927, 1928, 1929, 1930, 1931, 1932, 1933, 1934, 1935,
1936, 1937, 1938, 1939, 1940, 1941, 1942, 1943, 1944, 1945, 1946, 1947,
1948, 1949, 1950, 1951, 1952, 1953, 1954, 1955, 1956, 1957, 1958, 1959,
1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 1969, 1970, 1971,
1972, 1973, 1974, 1975, 1976, 1977, 1978, 1979, 1980, 1981, 1982, 1983,
1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995,
1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007,
2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019,
2020, 2021, 2022, 2023, 2024, 2025,

  ];
  const navigate = useNavigate();

  const [filter, setFilter] = useState({
    make: "",
    model: "",
    vehicletype: "",
    bodytype: "",
    saletype: "",
    Salvageorclean: "",
    state: "",
    zip: "",
    country: "",
    inventry: "",
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(filter);
    navigate("/quicksearch", {
      state: filter,
    });
  };

  return (
    <>
      <div className="find-car my-4">
        <div className="container-fluid">
          <div className="find-car-form">
            <h1 className=" my-2 theme-color">Quick Search</h1>
            <form action="#" onSubmit={handleSubmit}>
              <div className="row my-4">
                <div className="col">
                  <div className="form-group">
                    <label className="">Inventory</label>
                    <select
                      value={filter.inventry}
                      className="nice-select select"
                      onChange={(e) =>
                        setFilter({ ...filter, inventry: e.target.value })
                      }
                    >
                      <option value="">Inventory</option>
                      <option value="Copart Inventory">Copart Inventory</option>
                      <option value="IAAI Inventory">IAAI Inventory</option>
                      <option value="All Inventory">All Inventory</option>
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="">Year</label>
                    <select className="nice-select select">
                      {year.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="">Make</label>
                    <select
                      value={filter.make}
                      onChange={(e) =>
                        setFilter({ ...filter, make: e.target.value })
                      }
                      className="nice-select select"
                    >
                      <option value="">Make</option>
                      <option value="Ferrari">Ferrari</option>
                      <option value="Hyundai">Hyundai</option>
                      <option value="Mercedes Benz">Mercedes Benz</option>
                      <option value="Toyota">Toyota</option>
                      <option value="BMW">BMW</option>
                      <option value="Nissan">Nissan</option>
                      <option value="Acura">Acura</option>
                      <option value="Audi">Audi</option>
                      <option value="GMC">GMC</option>
                      <option value="Honda">Honda</option>
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label className="">Model</label>
                    <select
                      value={filter.model}
                      className="nice-select select"
                      onChange={(e) =>
                        setFilter({ ...filter, model: e.target.value })
                      }
                    >
                      <option value="All Model">All Model</option>
                      <option value="3-Series">3-Series </option>
                      <option value="Carrera">Carrera</option>
                      <option value="G-TR">G-TR</option>
                      <option value="Macan">Macan</option>
                      <option value="N-Series">N-Series</option>
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label>Vehicle Type</label>
                    <select
                      value={filter.vehicletype}
                      className="nice-select select"
                      onChange={(e) =>
                        setFilter({ ...filter, vehicletype: e.target.value })
                      }
                    >
                      <option value="">All Vehicle Type</option>
                      <option value="Automobile">Automobile</option>
                      <option value="Motorcycle">Motorcycle</option>
                      <option value="ATV">ATV</option>
                      <option value="Watercraft">Watercraft</option>
                      <option value="Jet Sky">Jet Sky</option>
                      <option value="Boat">Boat</option>
                      <option value="Trailers">Trailers</option>
                      <option value="Mobile Home">Mobile Home</option>
                      <option value="Emergency Equipment">
                        Emergency Equipment
                      </option>
                      <option value="Industrial Equipment">
                        Industrial Equipment
                      </option>
                      <option value="Truck">Truck</option>
                      <option value="Bus">Bus</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label>Body Type</label>
                    <select
                      value={filter.bodytype}
                      className="nice-select select"
                      onChange={(e) =>
                        setFilter({ ...filter, bodytype: e.target.value })
                      }
                    >
                      <option value="All Vehicle Type">All Vehicle Type</option>
                      <option value="Vehicle">Vehicle</option>
                      <option value="Bike">Bike</option>
                      <option value="Truck">Truck</option>
                      <option value="ATVs">ATVs</option>
                    </select>
                  </div>
                </div>
                <div className="col">
                  <div className="form-group">
                    <label>Sale Type</label>
                    <select
                      value={filter.saletype}
                      className="nice-select select"
                      onChange={(e) =>
                        setFilter({ ...filter, saletype: e.target.value })
                      }
                    >
                      <option value="Buy Now">Buy Now</option>
                      <option value="others">others</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-3">
                  <div className="form-group">
                    <label>Salvage or clean/clear</label>
                    <select
                      value={filter.Salvageorclean}
                      className="nice-select select"
                      onChange={(e) =>
                        setFilter({ ...filter, Salvageorclean: e.target.value })
                      }
                    >
                      <option value="" disabled selected>
                        Title
                      </option>
                      <option value="Clean/Clear">Clean/Clear</option>
                      <option value="Salvage">Salvage</option>
                      <option value="Bill of Sale">Bill of Sale</option>
                      <option value="All">All</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="form-group">
                    <label>State</label>
                    <input
                      value={filter.state}
                      onChange={(e) =>
                        setFilter({ ...filter, state: e.target.value })
                      }
                      className="form-control"
                      placeholder="State"
                      type="search"
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="form-group">
                    <label>Zip</label>
                    <input
                      value={filter.zip}
                      onChange={(e) =>
                        setFilter({ ...filter, zip: e.target.value })
                      }
                      className="form-control"
                      placeholder="Zip"
                      type="search"
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="form-group">
                    <label>Country</label>
                    <input
                      value={filter.country}
                      onChange={(e) =>
                        setFilter({ ...filter, country: e.target.value })
                      }
                      className="form-control"
                      placeholder="Country"
                      type="search"
                    />
                  </div>
                </div>
                <div className="col-lg-3 align-self-center pe-4 mt-4">
                  <button type="submit" className="theme-btn ms-auto d-block">
                    <span className="far fa-search"></span> Search
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeFilter;
